import baseRoute from '../baseRoute';

export default `${baseRoute}/credentials` as const;
